import React, { useState, forwardRef, useLayoutEffect } from "react"
import Button from "./button"
import Input from "./input"
import { useFetch } from "../hooks/useFetch"
import { FormSources, API_BASE_URL } from "../utils/constants"
import { AnimatePresence } from "framer-motion"
import { ErrorAlert, SuccessAlert } from "./alert"

const _ContactForm = function ContactForm(
  { source = FormSources.Contact, prefillMessage },
  ref
) {
  const { status, error, request } = useFetch()
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  })
  const handleChange = e => {
    const { name, value } = e.target

    setForm(form => ({ ...form, [name]: value }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    request(() => {
      fetch(`${API_BASE_URL}/order/distributor/mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...form,
          from: source,
        }),
      })
    })
  }

  useLayoutEffect(() => {
    if (prefillMessage) {
      setForm(form => ({ ...form, message: prefillMessage }))
    }
  }, [prefillMessage])

  return (
    <form ref={ref} onSubmit={handleSubmit}>
      <Input
        className="mb-10"
        label="Full Name"
        name="name"
        value={form.name}
        onChange={handleChange}
        required
      />
      <Input
        className="mb-10"
        label="Email Address"
        name="email"
        type="email"
        value={form.email}
        onChange={handleChange}
      />
      <Input
        className="mb-8"
        multiline
        label="Message"
        name="message"
        value={form.message}
        onChange={handleChange}
      />
      <div className="flex justify-end">
        <Button
          loading={status === "fetching"}
          disabled={status === "fetching"}
          type="submit"
        >
          Submit
        </Button>
      </div>
      <AnimatePresence>
        <div className="mt-4">
          {status === "error" && <ErrorAlert>{error}</ErrorAlert>}
          {status === "success" && (
            <SuccessAlert>
              Thanks for reaching out. We will get back to you soon.
            </SuccessAlert>
          )}
        </div>
      </AnimatePresence>
    </form>
  )
}

export const ContactForm = forwardRef(_ContactForm)
